import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCmWd_AK-1kJCzo1OjVUpJURMweC75vFdw',
  authDomain: 'stx-tg.firebaseapp.com',
  projectId: 'stx-tg',
  storageBucket: 'stx-tg.firebasestorage.app',
  messagingSenderId: '857363878899',
  appId: '1:857363878899:web:d8d67af271e014b6747886',
  measurementId: 'G-K3Z3F5TCD9',
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
